import type { ListenerEffectAPI } from "@reduxjs/toolkit";
import { editStorageObject } from "../../../../../app/state/storageObjectSlice/actions/actions";
import type { AppDispatch, RootState } from "../../../types";
import { appListenerMiddleware } from "../../appListenerMiddleware";
import { serviceHandlers } from "../handlers/storageHandlers";

export function updateStorageObjectListener() {
  appListenerMiddleware.startListening({
    actionCreator: editStorageObject.fulfilled,
    effect: async (action, listenerApi) => {
      const { service, id, skipUpdateListener } = action.meta.arg;
      const updatedValue = action.payload;

      if (!updatedValue || updatedValue.value === null || skipUpdateListener)
        return;

      const handler = serviceHandlers[service];

      if (handler?.onUpdate) {
        await handler.onUpdate(
          listenerApi as ListenerEffectAPI<RootState, AppDispatch>,
          id,
          updatedValue.value,
          action.meta
        );
      }
    },
  });
}
